export function getApiUrl(): string {
  if (import.meta.env.VITE_API_URL) {
    console.log('[API] Using VITE_API_URL:', import.meta.env.VITE_API_URL);
    return import.meta.env.VITE_API_URL;
  }

  if (import.meta.env.VITE_LOCAL_API_URL) {
    console.log('[API] Using VITE_LOCAL_API_URL:', import.meta.env.VITE_LOCAL_API_URL);
    return import.meta.env.VITE_LOCAL_API_URL;
  }

  const hostname = window.location.hostname;
  console.log('[API] Detected hostname:', hostname);

  if (hostname === 'path-finder-dev.web.app' || hostname.includes('dev')) {
    const devUrl = 'https://path-finder-api-dev-654916158760.us-central1.run.app';
    console.log('[API] Using dev backend:', devUrl);
    return devUrl;
  }

  if (
    hostname === 'path-finder-prod.web.app' ||
    hostname === 'pathfinder-8fba8.web.app' ||
    hostname === 'pathfindergy.app' ||
    hostname === 'www.pathfindergy.app'
  ) {
    const prodUrl = 'https://path-finder-api-prod-654916158760.us-central1.run.app';
    console.log('[API] Using prod backend:', prodUrl);
    return prodUrl;
  }

  // Flask backend defaults to PORT=8080 in backend/app.py.
  const localUrl = 'http://localhost:8080';
  console.log('[API] Using local backend:', localUrl);
  return localUrl;
}